<div class="panel-content d-flex rounded-bottom border-faded border-left-0 border-right-0 border-bottom-0 text-muted m-3">
  <div class="btn-group btn-panel">
    <button type="button" *ngIf="auxSaveAction" class="btn btn-primary" (click)="saveClicked()">Salvar</button>
    <button type="button" *ngIf="auxCancelAction" class="btn btn-default" (click)="cancelClicked()">Cancelar</button>
  </div>
</div>